import { Injectable } from "@angular/core";

@Injectable()
export class RevisionCompareUrlService {
  public for(repoUrl: string, previousRevision: string, revision: string) {
    // We can't link to a repo if there isn't one to link to.
    if (repoUrl == null) {
      return;
    }
    // We can't link to the current revision or a diff, if the current
    // revision is unknown.
    if (revision == null) {
      return;
    }

    repoUrl = this.httpFormatRepo(repoUrl);

    if (!previousRevision) {
      return this.commitUrl(repoUrl, revision);
    }

    return this.compareUrl(repoUrl, previousRevision, revision);
  }

  // Builds a URL to the project.
  public fromIntegration(integrations: { [index: string]: any }) {
    for (const key of Object.keys(integrations)) {
      let username;
      let repository;

      switch (key) {
        case "github":
          username = integrations[key].username;
          repository = integrations[key].repository;
          if (integrations[key].host) {
            return `https://${integrations[key].host}/${username}/${repository}`;
          } else {
            return `https://github.com/${username}/${repository}`;
          }
        case "gitlab":
          username = integrations[key].username;
          repository = integrations[key].repository;
          if (integrations[key].host) {
            return `https://${integrations[key].host}/${username}/${repository}`;
          } else {
            return `https://gitlab.com/${username}/${repository}`;
          }
        case "bitbucket":
          username = integrations[key].accountName;
          repository = integrations[key].repoName;
          return `https://bitbucket.org/${username}/${repository}`;
        default:
          return null;
      }
    }

    return null;
  }

  public httpFormatRepo(repo: string) {
    if (!repo.startsWith("git@")) {
      return repo.replace(/\.git$/, "");
    }

    const host = (repo.match(/git@(.+):/) || [])[1];
    const user = (repo.match(/:(.+)\//) || [])[1];
    const repoName = (repo.match(/\/(.+)\.git/) || [])[1];
    if (!host || !user || !repoName) {
      return repo;
    }
    return `https://${host}/${user}/${repoName}`;
  }

  private compareUrl(
    repoUrl: string,
    previousRevision: string,
    revision: string,
  ) {
    if (previousRevision === revision) {
      return this.commitUrl(repoUrl, revision);
    }

    if (repoUrl.match(/(@|\/\/)bitbucket\.org\//)) {
      return `${repoUrl}/compare/${revision}..${previousRevision}#diff`;
    } else {
      // Same format for: GitHub, GitLab.
      return `${repoUrl}/compare/${previousRevision}...${revision}`;
    }
  }

  private commitUrl(repoUrl: string, revision: string) {
    if (repoUrl.match(/(@|\/\/)bitbucket\.org\//)) {
      return `${repoUrl}/commits/${revision}`;
    } else {
      // Same format for: GitHub, GitLab.
      return `${repoUrl}/commit/${revision}`;
    }
  }
}
